import { VBtn } from 'vuetify/lib/components/VBtn';
import { VForm } from 'vuetify/lib/components/VForm';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextField } from 'vuetify/lib/components/VTextField';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "form", attrs: { id: "productSpecsForm" } },
    [
      _vm.loaded
        ? _c(
            VForm,
            {
              ref: "form",
              attrs: { "lazy-validation": "" },
              model: {
                value: _vm.valid,
                callback: function ($$v) {
                  _vm.valid = $$v
                },
                expression: "valid",
              },
            },
            [
              _c("product-select", {
                model: {
                  value: _vm.productSpecs.productId,
                  callback: function ($$v) {
                    _vm.$set(_vm.productSpecs, "productId", $$v)
                  },
                  expression: "productSpecs.productId",
                },
              }),
              _vm._l(_vm.productSpecs.elements, function (e, index) {
                return _c(
                  "div",
                  { key: e.id, staticClass: "d-flex justify-space-between" },
                  [
                    _c(
                      "div",
                      {
                        staticClass: "my-auto mx-5",
                        staticStyle: { "min-width": "100px" },
                      },
                      [
                        _vm._v(
                          _vm._s(e.element.elementName) +
                            " (" +
                            _vm._s(e.element.symbol) +
                            ")"
                        ),
                      ]
                    ),
                    _c(VTextField, {
                      staticClass: "mx-5",
                      attrs: {
                        clearable: "",
                        label: "Min",
                        placeholder: "Leave blank for no limit",
                      },
                      model: {
                        value: e.minPercent,
                        callback: function ($$v) {
                          _vm.$set(e, "minPercent", $$v)
                        },
                        expression: "e.minPercent",
                      },
                    }),
                    _c(VTextField, {
                      staticClass: "mx-5",
                      attrs: {
                        clearable: "",
                        label: "Max",
                        placeholder: "Leave blank for no limit",
                      },
                      model: {
                        value: e.maxPercent,
                        callback: function ($$v) {
                          _vm.$set(e, "maxPercent", $$v)
                        },
                        expression: "e.maxPercent",
                      },
                    }),
                    _c(
                      VBtn,
                      {
                        staticClass: "my-auto mx-5",
                        attrs: { icon: "" },
                        on: {
                          click: function ($event) {
                            return _vm.remove(e, index)
                          },
                        },
                      },
                      [_c(VIcon, [_vm._v("mdi-delete-outline")])],
                      1
                    ),
                  ],
                  1
                )
              }),
              _c(
                "div",
                { staticClass: "d-flex flex-row mt-4 mx-5" },
                [
                  _c(VSelect, {
                    attrs: {
                      items: _vm.productSpecs.relations.elements,
                      label: "Elements",
                      multiple: false,
                      "item-text": "label",
                      "item-value": "id",
                      clearable: "",
                      "return-object": "",
                    },
                    model: {
                      value: _vm.newElement,
                      callback: function ($$v) {
                        _vm.newElement = $$v
                      },
                      expression: "newElement",
                    },
                  }),
                  _c(
                    VBtn,
                    { staticClass: "mt-3 ml-5", on: { click: _vm.addElement } },
                    [_vm._v("Add")]
                  ),
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "mt-4 d-flex justify-space-between" },
                [
                  _c(VBtn, { on: { click: _vm.goBack } }, [
                    _vm._v(" Back "),
                  ]),
                  _c(
                    VBtn,
                    {
                      attrs: { color: "primary" },
                      on: { click: _vm.handleSubmit },
                    },
                    [_vm._v(" " + _vm._s(_vm.id ? "Update" : "Save") + " ")]
                  ),
                  _c("span"),
                ],
                1
              ),
            ],
            2
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }